import { render, staticRenderFns } from "./CSVParser.component.vue?vue&type=template&id=af3f1c80&scoped=true"
import script from "./CSVParser.component.ts?vue&type=script&lang=js&external"
export * from "./CSVParser.component.ts?vue&type=script&lang=js&external"
import style0 from "./CSVParser.component.vue?vue&type=style&index=0&id=af3f1c80&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3f1c80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af3f1c80')) {
      api.createRecord('af3f1c80', component.options)
    } else {
      api.reload('af3f1c80', component.options)
    }
    module.hot.accept("./CSVParser.component.vue?vue&type=template&id=af3f1c80&scoped=true", function () {
      api.rerender('af3f1c80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/iot-simulator/CSVParser.component.vue"
export default component.exports